import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Link from 'next/link';
import { formatNumber, formatDollars } from '@@client/lib/numbers';
import { classnames } from '@@client/lib/classes';
import { hasRetailPrice } from '@@client/parts/parts-helper';
import PartPhotoFeatured from '@@client/parts/PartPhotoFeatured';
import PreventDefaultClick from '@@client/components/PreventDefaultClick';
import PartCartActions from './PartCartActions';
export default function PartCard(_ref) {
  var partInfo = _ref.partInfo,
      _ref$allowMakeOffer = _ref.allowMakeOffer,
      allowMakeOffer = _ref$allowMakeOffer === void 0 ? true : _ref$allowMakeOffer;
  var classNames = classnames(['part', 'm--lift-hover']);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-4218647247",
      children: /*#__PURE__*/_jsx(Link, {
        href: "/part/[id]",
        as: "/part/".concat(partInfo.inventoryId),
        children: /*#__PURE__*/_jsxs("a", {
          className: "jsx-4218647247" + " " + (classNames || ""),
          children: [/*#__PURE__*/_jsx("div", {
            className: "jsx-4218647247" + " " + 'photo',
            children: /*#__PURE__*/_jsx(PartPhotoFeatured, {
              partInfo: partInfo
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "jsx-4218647247" + " " + 'description',
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-4218647247" + " " + 'part-type',
              children: partInfo.partTypeName
            }), /*#__PURE__*/_jsxs("div", {
              className: "jsx-4218647247" + " " + 'vehicle',
              children: [partInfo.modelYear, " ", partInfo.makeName, " ", partInfo.carlineName]
            }), /*#__PURE__*/_jsx("div", {
              className: "jsx-4218647247" + " " + 'mileage',
              children: partInfo.mileage ? 'Miles: ' + formatNumber(partInfo.mileage) : null
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "jsx-4218647247" + " " + 'price',
            children: hasRetailPrice(partInfo.retailPrice) ? /*#__PURE__*/_jsx("span", {
              className: "jsx-4218647247" + " " + 'amount',
              children: formatDollars(partInfo.retailPrice)
            }) : /*#__PURE__*/_jsx("span", {
              className: "jsx-4218647247" + " " + 'make-offer-price',
              children: "Make an offer"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "jsx-4218647247" + " " + 'actions',
            children: /*#__PURE__*/_jsx(PreventDefaultClick, {
              children: /*#__PURE__*/_jsx(PartCartActions, {
                partInfo: partInfo,
                allowMakeOffer: allowMakeOffer
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "4218647247",
      children: [".part.jsx-4218647247{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;border:1px solid #CCD0E0;background:white;overflow:hidden;-webkit-text-decoration:none;text-decoration:none;color:black;height:100%;}", ".photo.jsx-4218647247{border-bottom:2px solid #1C357D;height:154px;}", ".description.jsx-4218647247{padding:10px;-webkit-box-flex:1;-ms-flex-positive:1;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;}", ".part-type.jsx-4218647247{font-weight:700;line-height:1.25;margin-bottom:3px;}", ".vehicle.jsx-4218647247,.mileage.jsx-4218647247{font-size:0.8125rem;}", ".price.jsx-4218647247{padding:10px;}", ".price.jsx-4218647247::after{content:'';display:block;border-bottom:1px solid #9BA3C3;margin-top:10px;}", ".price.jsx-4218647247 .amount.jsx-4218647247{font-size:1.125rem;font-weight:700;}", ".price.jsx-4218647247 .make-offer-price.jsx-4218647247{font-style:italic;}", ".actions.jsx-4218647247{padding:0 10px 10px;}"]
    })]
  });
}